import { Company, ComplianceArea, User, TrustReport } from '../_models/index';


export class Tenant {
  tenantId: number;
  companyName: string;
  databaseName: string;
  emailAddress: string;

  users: User[];

  companies: Company[];

  creationDate: Date;

  complianceAreas: ComplianceArea[];

  canCreateComplianceArea: boolean;

  maxUsers: number;
  maxTrainingUsers: number;
  maxPartnerUsers: number;
  canCreatePartnerProjects: boolean;
  maxProjects: number;

  expires?: boolean;
  expirationDate?: Date;
  isTrainingEnabled?: boolean;
  isAPIEnabled?: boolean;
  isCloneEnabled?: boolean;
  isPracticeGuidanceEnabled?: boolean;
  isPolicyVersionEnabled?: boolean;
  isPdfReportsEnabled?: boolean;

  maxSurveyUsers: number;
  maxProfiles?: number;
  maxSurveys?: number;
  advisor?: string;
  moAdvisory?: string;
  isLoggingEnabled?: boolean;
  isProjectsEnabled?: boolean;
  isControlsEnabled?: boolean;
  isAuditEnabled?: boolean;
  isEditICSAndAPEnabled?: boolean;
  isSecurityAssessmentTabEnabled?: boolean;
  isRiskAssessmentTabEnabled?: boolean;

  existingComplianceAreas?: string[];
  existingPolicies?: string[];
  existingProfiles?: string[];
  existingAssessments?: string[];
  existingTrainings?: string[];
  existingAudits?: string[];
  existingWorkstreams?: string[];
  existingReferenceResources?: string[];
  existingRecommendedSolutions?: string[];

  awsMarketplaceCustomerAccountId?: string;
  awsMarketplaceCustomerIdentifier?: string;
  awsMarketplaceProductCode?: string;
  awsMarketplaceToken?: string;

  defaultTrustReport?: TrustReport;
  constructor(tenantId: number) {
    this.tenantId = tenantId;
    this.complianceAreas = [];
  }
}

